<template>
  <el-select
    v-model="dataValue"
    style="width: 150px;"
    placeholder="请选择上架状态">
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
import { statusList } from './utils'
export default {
  name: 'GoodsStatusSelect',
  props: {
    value: { type: Number }
  },
  data() {
    return {
      list: statusList
    }
  },
  computed: {
    dataValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
